// Season-specific settings. Update this file each year — the calendar,
// checkout, and database paths all derive from these values.
export const YEAR = 2026;

export const EVENT_TITLE = `Labor Day Weekend ${YEAR}`;

// Bookable dates (YYYY-MM-DD), in order.
export const DATES = [
  "2026-09-04",
  "2026-09-05",
  "2026-09-06",
  "2026-09-07",
];

// Inventory available per day (what guests can book).
export const MAX_SETS_PER_DAY = 55;

// Physical set positions per day, taken from the beach service's chart.
// They arrange the sets as a three-sided box opening toward the water on
// the left, numbering along the top row, down the right column, then back
// along the bottom — so the highest number ends up at the far left of the
// bottom row, nearest the opening. `top`/`right`/`bottom` are how many
// positions sit on each side. All four were read off the chart.
export const SPOT_LAYOUTS = {
  "2026-09-04": { top: 12, right: 15, bottom: 12, confirmed: true }, // 39
  "2026-09-05": { top: 17, right: 21, bottom: 17, confirmed: true }, // 55
  "2026-09-06": { top: 17, right: 21, bottom: 17, confirmed: true }, // 55
  "2026-09-07": { top: 15, right: 18, bottom: 15, confirmed: true }, // 48
};

// Temporarily pause new account sign-ups so returning guests get a
// grace period to book. Flip to true to reopen sign-ups.
export const SIGNUPS_ENABLED = true;

// Suspend booking: watermarks the main page and disables reservations.
// Flip to false to reopen booking.
export const BOOKING_SUSPENDED = true;

// Bookings are invoiced in rounds. Everything taken before the first
// invoice is round 1; bump this each time booking reopens after an
// invoice so the new bookings can be totalled on their own. Confirmations
// saved before rounds existed count as round 1. The per-day cap and the
// beach spot map deliberately span every round — only the money is split.
export const BOOKING_ROUND = 2;
export const SUSPENSION_MESSAGE =
  "Contact Dustin if you need to make adjustments to your reservation.";

// Pricing per set (2 chairs + 1 umbrella), after taxes. Derived from the
// 2026 Dolphin Beach Services list (pre-tax: 1 day $58, 2 days $110,
// 3 days $147, 4 days $192) with the ~14.49% tax factor, giving after-tax
// totals of $66.40 / $125.94 / $168.30 / $219.80.
export const RATE_PER_DAY = 66.4;
// Per-set, per-day discount when booked on 2+ consecutive days.
export const TWO_DAY_DISCOUNT = 3.43;
// Additional per-set, per-day discount on 3+ consecutive days.
export const THREE_DAY_EXTRA_DISCOUNT = 6.87;
// Additional per-set, per-day discount on 4 consecutive days.
export const FOUR_DAY_EXTRA_DISCOUNT = 1.15;
